<template>
  <div id="app">
    <Header/>
    <router-view/>
    <Footer/>
  </div>
</template>
<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
export default {
  name: "App",
  components: { Footer, Header },
  computed: {
    theme() {
      return this.$store.state.theme;
    }
  },
  data() {
    return {
      apiSpace: this.$store.state.apiSpace,
      apiToken: this.$store.state.apiToken
    };
  },
  methods: {
    getBuilds() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntries({
          content_type: "build",
          order: "-fields.sort"
        })
        .then(entries => {
          this.$store.dispatch("getBuilds", entries.items);
        })
        .catch(error => {
          console.log(error);
        });
    },
    getNews() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntries({
          content_type: "news",
          order: "-fields.manualDate"
        })
        .then(entries => {
          this.$store.dispatch("getNews", entries.items);
        })
        .catch(error => {
          console.log(error);
        });
    },
    themeSwitch() {
      let root = document.getElementsByTagName("html")[0];
      root.setAttribute("data-theme", this.theme);
    }
  },
  mounted() {
    this.getBuilds();
    this.getNews();
    this.themeSwitch();
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      let root = document.getElementsByTagName("html")[0];
      root.setAttribute("data-theme", "dark");
      this.$store.dispatch("themeSwitch", "dark");
    }
  }
};
</script>
<style lang="scss">
@import "assets/css/reset";
@import "assets/css/base";
</style>